/* "This is how Scripture finally makes sense" interactive page tabs (from the reference page). */
(() => {
    const managerKey = '__ebmsUsmSwiper122CopyV1Manager';

    if (
      window[managerKey] &&
      typeof window[managerKey].boot === 'function'
    ) {
      window[managerKey].boot(document);
      return;
    }

    const rootSelector = '[data-ebms-usm-swiper-122-copy-v1]';



    const collectRoots = scope => {
      const roots = [];

      if (
        scope &&
        scope.nodeType === 1 &&
        typeof scope.matches === 'function' &&
        scope.matches(rootSelector)
      ) {
        roots.push(scope);
      }

      if (
        scope &&
        typeof scope.querySelectorAll === 'function'
      ) {
        roots.push(
          ...scope.querySelectorAll(rootSelector)
        );
      }

      return roots;
    };

    const swiperLibraryRegistryName =
      '__sectionStoreSwiper1220';
    const swiperScriptUrl =
      'https://cdn.jsdelivr.net/npm/swiper@12.2.0/swiper-bundle.min.js';
    const swiperScriptIntegrity =
      'sha256-HjE1VbBMubUnO3qBcVhwigX1jhj5HZekI52rb2jSPEo=';
    const swiperLoadTimeoutMs = 8000;
    let swiperLoaderPromise = null;

    const waitForDocumentParsed = () => {
      if (document.readyState !== 'loading') {
        return Promise.resolve();
      }

      return new Promise(resolve => {
        document.addEventListener(
          'DOMContentLoaded',
          resolve,
          { once: true }
        );
      });
    };

    const restorePreviousSwiperGlobal = previousSwiper => {
      if (typeof previousSwiper === 'undefined') {
        try {
          const deleted = delete window.Swiper;

          if (!deleted) {
            window.Swiper = undefined;
          }
        } catch (error) {
          window.Swiper = undefined;
        }
      } else {
        window.Swiper = previousSwiper;
      }
    };

    const loadSharedSwiper = () => {
      const existingState =
        window[swiperLibraryRegistryName];

      if (
        existingState &&
        typeof existingState.SwiperClass === 'function'
      ) {
        return Promise.resolve(
          existingState.SwiperClass
        );
      }

      if (
        existingState &&
        existingState.promise
      ) {
        return existingState.promise;
      }

      const state = {
        SwiperClass: null,
        promise: null
      };

      state.promise = new Promise((resolve, reject) => {
        const previousSwiper = window.Swiper;
        const scriptElement =
          document.createElement('script');
        const scriptParent =
          document.head || document.documentElement;
        let settled = false;
        let timeoutId = null;

        const clearLoadTimeout = () => {
          if (timeoutId !== null) {
            window.clearTimeout(timeoutId);
            timeoutId = null;
          }
        };

        const finishWithError = message => {
          if (settled) {
            return;
          }

          settled = true;
          clearLoadTimeout();
          restorePreviousSwiperGlobal(previousSwiper);
          scriptElement.remove();

          if (
            window[swiperLibraryRegistryName] === state
          ) {
            delete window[swiperLibraryRegistryName];
          }

          reject(new Error(message));
        };

        scriptElement.src = swiperScriptUrl;
        scriptElement.async = true;
        scriptElement.integrity =
          swiperScriptIntegrity;
        scriptElement.crossOrigin = 'anonymous';
        scriptElement.referrerPolicy = 'no-referrer';
        scriptElement.dataset.sectionStoreSwiperVersion =
          '12.2.0';

        scriptElement.addEventListener(
          'load',
          () => {
            if (settled) {
              /*
                A request removed after the timeout can still complete in
                some browsers. Restore the prior global again so a late
                UMD execution cannot leave window.Swiper changed.
              */
              restorePreviousSwiperGlobal(previousSwiper);
              return;
            }

            const loadedSwiper = window.Swiper;
            restorePreviousSwiperGlobal(previousSwiper);

            if (typeof loadedSwiper !== 'function') {
              finishWithError(
                'Swiper 12.2.0 loaded without exposing a valid constructor.'
              );
              return;
            }

            settled = true;
            clearLoadTimeout();
            state.SwiperClass = loadedSwiper;
            resolve(loadedSwiper);
          },
          { once: true }
        );

        scriptElement.addEventListener(
          'error',
          () => {
            finishWithError(
              'Swiper 12.2.0 could not be loaded.'
            );
          },
          { once: true }
        );

        if (!scriptParent) {
          finishWithError(
            'The page has no valid location for the Swiper library.'
          );
          return;
        }

        timeoutId = window.setTimeout(() => {
          finishWithError(
            'Swiper 12.2.0 timed out while loading.'
          );
        }, swiperLoadTimeoutMs);

        scriptParent.appendChild(scriptElement);
      });

      window[swiperLibraryRegistryName] = state;
      return state.promise;
    };

    const ensureSwiper = () => {
      if (swiperLoaderPromise) {
        return swiperLoaderPromise;
      }

      /*
        Both this block and SS Slider #2 use the same exact-version
        registry. Whichever section loads first supplies the constructor,
        so the PDP does not execute two separate Swiper 12.2.0 bundles.
        Any pre-existing window.Swiper value is restored after capture.
      */
      swiperLoaderPromise = waitForDocumentParsed()
        .then(loadSharedSwiper)
        .catch(error => {
          swiperLoaderPromise = null;
          throw error;
        });

      return swiperLoaderPromise;
    };

    const manager = {
      boot(scope = document) {
        collectRoots(scope).forEach(root => {
          manager.init(root);
        });
      },

      destroy(scope) {
        collectRoots(scope).forEach(root => {
          if (
            typeof root.__ebmsUsmV2Cleanup ===
              'function'
          ) {
            root.__ebmsUsmV2Cleanup();
          }
        });
      },

      init(root) {
        if (
          !root ||
          root.dataset.usmInitialized === 'true'
        ) {
          return;
        }

        const copyNode = root.querySelector('[data-usm-copy]');
        let pages;

        try {
          pages = JSON.parse(copyNode?.textContent || 'null');
        } catch (error) {
          root.dataset.usmInitError = 'invalid-copy-json';
          return;
        }

        const hasValidCopy = [['context', 7], ['story', 2]].every(
          ([page, count]) => Array.isArray(pages?.[page]) &&
            pages[page].length === count &&
            pages[page].every(item =>
              typeof item?.title === 'string' &&
              typeof item?.copy === 'string'
            )
        );

        if (!hasValidCopy) {
          root.dataset.usmInitError = 'invalid-copy-shape';
          return;
        }

        const tabs = [
          ...root.querySelectorAll('[data-usm-page]')
        ];
        const viewport =
          root.querySelector('[data-usm-viewport]');
        const rail =
          root.querySelector('[data-usm-rail]');
        const slides = [
          ...root.querySelectorAll('[data-usm-slide]')
        ];
        const card =
          root.querySelector('[data-usm-card]');
        const cardTitle =
          root.querySelector('[data-usm-card-title]');
        const cardCopy =
          root.querySelector('[data-usm-card-copy]');

        const hasEveryPage =
          Object.keys(pages).every(page =>
            slides.some(
              slide =>
                slide.dataset.usmSlide === page
            )
          );

        if (
          !viewport ||
          !rail ||
          !card ||
          !cardTitle ||
          !cardCopy ||
          tabs.length !== 2 ||
          !hasEveryPage
        ) {
          root.dataset.usmInitError =
            'missing-required-markup';
          return;
        }

        root.dataset.usmInitialized = 'true';
        delete root.dataset.usmInitError;

        const cleanupTasks = [];
        const listen = (
          target,
          type,
          handler,
          options
        ) => {
          target.addEventListener(
            type,
            handler,
            options
          );

          const cleanup = () => {
            target.removeEventListener(
              type,
              handler,
              options
            );
          };

          cleanupTasks.push(cleanup);
          return cleanup;
        };

        const desktopQuery =
          window.matchMedia('(min-width: 990px)');
        const tabletQuery =
          window.matchMedia('(min-width: 750px)');

        let currentPage = 'context';
        let suppressClickUntil = 0;
        let swiperInstance = null;
        let swiperInitToken = 0;
        let swiperGestureStartX = null;
        let swiperGestureMoved = false;
        let removePageFallbackSwipe = null;
        let isDestroyed = false;
        const pageOrder = ['context', 'story'];
        const selected = {
          context: 3,
          story: 0
        };

        slides.forEach(slide => {
          const page = slide.dataset.usmSlide;

          slide
            .querySelectorAll('[data-usm-section]')
            .forEach(target => {
              const index =
                Number(target.dataset.usmSection);
              const item = pages[page]?.[index];

              if (item) {
                target.setAttribute(
                  'aria-label',
                  item.title
                );
              }
            });
        });

        const getPreviousPeek = () =>
          tabletQuery.matches
            ? Math.min(
                76,
                viewport.clientWidth * 0.14
              )
            : Math.min(
                36,
                viewport.clientWidth * 0.1
              );

        const getSwiperOffsetAfter = () => {
          const storySlide = slides.find(
            slide =>
              slide.dataset.usmSlide === 'story'
          );

          if (!storySlide) {
            return 0;
          }

          const slideWidth =
            storySlide.getBoundingClientRect().width;
          const offset =
            viewport.clientWidth -
            slideWidth -
            getPreviousPeek();

          return Math.max(0, Math.round(offset));
        };

        const positionRail = () => {
          const activeSlide =
            root.querySelector(
              `[data-usm-slide="${currentPage}"]`
            );

          if (!activeSlide) {
            return;
          }

          if (desktopQuery.matches) {
            rail.style.transform = 'none';
            return;
          }

          if (
            swiperInstance &&
            !swiperInstance.destroyed
          ) {
            const targetIndex =
              pageOrder.indexOf(currentPage);

            if (
              targetIndex >= 0 &&
              swiperInstance.activeIndex !== targetIndex
            ) {
              swiperInstance.slideTo(targetIndex);
            }

            return;
          }

          if (currentPage === 'context') {
            rail.style.transform =
              'translate3d(0, 0, 0)';
            return;
          }

          const translateX =
            getPreviousPeek() - activeSlide.offsetLeft;

          rail.style.transform =
            `translate3d(${translateX}px, 0, 0)`;
        };

        const updateSpotlight = (
          slide,
          isCurrent
        ) => {
          const page = slide.dataset.usmSlide;
          const activeIndex = selected[page];
          const cutout =
            slide.querySelector('[data-usm-cutout]');
          const targets = [
            ...slide.querySelectorAll(
              '[data-usm-section]'
            )
          ];
          const showSpotlight =
            !desktopQuery.matches || isCurrent;

          targets.forEach(target => {
            const isSelected =
              Number(target.dataset.usmSection) ===
              activeIndex;
            const isActive =
              showSpotlight && isSelected;

            target.classList.toggle(
              'is-active',
              isActive
            );
            target.setAttribute(
              'aria-pressed',
              String(isActive)
            );
          });

          if (!cutout) {
            return;
          }

          if (!showSpotlight) {
            cutout.setAttribute('d', '');
            return;
          }

          const activeTarget = targets.find(
            target =>
              Number(target.dataset.usmSection) ===
              activeIndex
          );

          if (!activeTarget) {
            cutout.setAttribute('d', '');
            return;
          }

          const path = [
            ...activeTarget.querySelectorAll(
              '.ebms-usm-v2__region-hit'
            )
          ]
            .map(region =>
              region.getAttribute('d')
            )
            .filter(Boolean)
            .join(' ');

          cutout.setAttribute('d', path);
        };

        const render = () => {
          tabs.forEach(tab => {
            tab.setAttribute(
              'aria-pressed',
              String(
                tab.dataset.usmPage ===
                  currentPage
              )
            );
          });

          slides.forEach(slide => {
            const isCurrent =
              slide.dataset.usmSlide ===
              currentPage;
            const isAccessible =
              desktopQuery.matches || isCurrent;

            slide.classList.toggle(
              'is-current',
              isCurrent
            );
            slide.setAttribute(
              'aria-hidden',
              String(!isAccessible)
            );

            slide
              .querySelectorAll('[data-usm-section]')
              .forEach(target => {
                target.setAttribute(
                  'tabindex',
                  isAccessible ? '0' : '-1'
                );
              });

            updateSpotlight(slide, isCurrent);
          });

          const item =
            pages[currentPage]?.[
              selected[currentPage]
            ];

          if (item) {
            cardTitle.textContent = item.title;
            cardCopy.textContent = item.copy;
          }

          positionRail();
        };

        const changePage = page => {
          if (
            !pages[page] ||
            page === currentPage
          ) {
            return false;
          }

          currentPage = page;
          render();
          return true;
        };

        const chooseSection = (
          page,
          index
        ) => {
          if (!pages[page]?.[index]) {
            return false;
          }

          currentPage = page;
          selected[page] = index;
          render();
          return true;
        };

        const moveSection = direction => {
          const pageIndex =
            pageOrder.indexOf(currentPage);
          const items = pages[currentPage];
          const currentIndex =
            selected[currentPage];
          const nextIndex =
            currentIndex + direction;

          if (
            nextIndex >= 0 &&
            nextIndex < items.length
          ) {
            selected[currentPage] = nextIndex;
            render();
            return true;
          }

          if (direction > 0) {
            currentPage =
              pageIndex < pageOrder.length - 1
                ? pageOrder[pageIndex + 1]
                : pageOrder[0];
            selected[currentPage] = 0;
            render();
            return true;
          }

          if (direction < 0) {
            currentPage =
              pageIndex > 0
                ? pageOrder[pageIndex - 1]
                : pageOrder[
                    pageOrder.length - 1
                  ];
            selected[currentPage] =
              pages[currentPage].length - 1;
            render();
            return true;
          }

          return false;
        };

        tabs.forEach(tab => {
          listen(tab, 'click', () => {
            changePage(tab.dataset.usmPage);
          });
        });

        slides.forEach(slide => {
          const page = slide.dataset.usmSlide;

          listen(slide, 'click', () => {
            if (
              Date.now() < suppressClickUntil
            ) {
              return;
            }

            if (page !== currentPage) {
              changePage(page);
            }
          });

          slide
            .querySelectorAll('[data-usm-section]')
            .forEach(target => {
              const activate = event => {
                event.stopPropagation();

                if (
                  Date.now() < suppressClickUntil
                ) {
                  return;
                }

                chooseSection(
                  page,
                  Number(target.dataset.usmSection)
                );
              };

              listen(target, 'click', activate);
              listen(target, 'keydown', event => {
                if (
                  event.key !== 'Enter' &&
                  event.key !== ' '
                ) {
                  return;
                }

                event.preventDefault();
                activate(event);
              });
            });
        });

        root
          .querySelectorAll('[data-usm-direction]')
          .forEach(button => {
            listen(button, 'click', event => {
              if (
                Date.now() < suppressClickUntil
              ) {
                event.preventDefault();
                return;
              }

              moveSection(
                button.dataset.usmDirection ===
                  'next'
                  ? 1
                  : -1
              );
            });
          });

        const addSwipe = (
          element,
          onLeft,
          onRight
        ) => {
          /*
            The page carousel itself uses real Swiper 12.2.0.
            This helper is only for the description card,
            which changes the selected section rather than
            physically sliding pages.

            On touch devices use Touch Events (as Swiper 12.2.0
            does) instead of Pointer Events. This avoids the
            mobile edge cases that made the earlier detector
            feel less reliable.
          */
          const threshold = 5;
          const touchAngle = 45;
          const shortSwipeMs = 300;
          const longSwipeRatio = 0.5;
          const clickGuardDuration = 420;

          let startX = null;
          let startY = null;
          let startedAt = 0;
          let gestureAxis = null;
          let pointerId = null;
          const localCleanups = [];

          const addLocalListener = (
            target,
            type,
            handler,
            options
          ) => {
            target.addEventListener(
              type,
              handler,
              options
            );

            localCleanups.push(() => {
              target.removeEventListener(
                type,
                handler,
                options
              );
            });
          };

          const reset = () => {
            startX = null;
            startY = null;
            startedAt = 0;
            gestureAxis = null;
            pointerId = null;
          };

          const guardAgainstClick = () => {
            suppressClickUntil =
              Date.now() + clickGuardDuration;
          };

          const getAngle = (deltaX, deltaY) => {
            const absoluteX = Math.abs(deltaX);
            const absoluteY = Math.abs(deltaY);

            if (absoluteX === 0) {
              return 90;
            }

            return (
              Math.atan2(absoluteY, absoluteX) *
              180 /
              Math.PI
            );
          };

          const finishGesture = (
            deltaX,
            deltaY,
            elapsed
          ) => {
            const absoluteX = Math.abs(deltaX);
            const angle = getAngle(deltaX, deltaY);
            const isHorizontal =
              gestureAxis === 'horizontal' ||
              (
                gestureAxis === null &&
                absoluteX >= threshold &&
                angle <= touchAngle
              );

            if (!isHorizontal) {
              reset();
              return;
            }

            const isShortSwipe =
              elapsed <= shortSwipeMs &&
              absoluteX >= threshold;
            const isLongSwipe =
              elapsed > shortSwipeMs &&
              absoluteX >=
                Math.max(
                  threshold,
                  element.clientWidth *
                    longSwipeRatio
                );

            reset();

            if (!isShortSwipe && !isLongSwipe) {
              return;
            }

            const handled =
              deltaX < 0
                ? onLeft()
                : onRight();

            if (handled !== false) {
              guardAgainstClick();
            }
          };

          addLocalListener(
            element,
            'touchstart',
            event => {
              if (event.touches.length !== 1) {
                reset();
                return;
              }

              const touch = event.touches[0];
              startX = touch.clientX;
              startY = touch.clientY;
              startedAt = Date.now();
              gestureAxis = null;
            },
            { passive: true }
          );

          addLocalListener(
            element,
            'touchmove',
            event => {
              if (
                startX === null ||
                startY === null ||
                event.touches.length !== 1
              ) {
                return;
              }

              const touch = event.touches[0];
              const deltaX = touch.clientX - startX;
              const deltaY = touch.clientY - startY;
              const absoluteX = Math.abs(deltaX);
              const absoluteY = Math.abs(deltaY);

              if (
                gestureAxis === null &&
                Math.max(
                  absoluteX,
                  absoluteY
                ) >= threshold
              ) {
                gestureAxis =
                  getAngle(deltaX, deltaY) <=
                    touchAngle
                    ? 'horizontal'
                    : 'vertical';
              }

              if (gestureAxis === 'horizontal') {
                guardAgainstClick();

                if (event.cancelable) {
                  event.preventDefault();
                }
              }
            },
            { passive: false }
          );

          addLocalListener(
            element,
            'touchend',
            event => {
              if (
                startX === null ||
                startY === null ||
                event.changedTouches.length < 1
              ) {
                reset();
                return;
              }

              const touch = event.changedTouches[0];
              const deltaX = touch.clientX - startX;
              const deltaY = touch.clientY - startY;
              const elapsed = Math.max(
                1,
                Date.now() - startedAt
              );

              finishGesture(
                deltaX,
                deltaY,
                elapsed
              );
            },
            { passive: true }
          );

          addLocalListener(
            element,
            'touchcancel',
            reset,
            { passive: true }
          );

          /*
            Mouse/pen fallback. Touch pointers are ignored
            because touch events above are the preferred path.
          */
          addLocalListener(element, 'pointerdown', event => {
            if (
              event.pointerType === 'touch' ||
              event.isPrimary === false ||
              (
                event.pointerType === 'mouse' &&
                event.button !== 0
              )
            ) {
              return;
            }

            pointerId = event.pointerId;
            startX = event.clientX;
            startY = event.clientY;
            startedAt = Date.now();
            gestureAxis = null;
          });

          addLocalListener(element, 'pointermove', event => {
            if (
              pointerId === null ||
              event.pointerId !== pointerId ||
              startX === null ||
              startY === null
            ) {
              return;
            }

            const deltaX = event.clientX - startX;
            const deltaY = event.clientY - startY;
            const absoluteX = Math.abs(deltaX);
            const absoluteY = Math.abs(deltaY);

            if (
              gestureAxis === null &&
              Math.max(
                absoluteX,
                absoluteY
              ) >= threshold
            ) {
              gestureAxis =
                getAngle(deltaX, deltaY) <=
                  touchAngle
                  ? 'horizontal'
                  : 'vertical';
            }

            if (gestureAxis === 'horizontal') {
              guardAgainstClick();
            }
          });

          addLocalListener(element, 'pointerup', event => {
            if (
              pointerId === null ||
              event.pointerId !== pointerId ||
              startX === null ||
              startY === null
            ) {
              return;
            }

            const deltaX = event.clientX - startX;
            const deltaY = event.clientY - startY;
            const elapsed = Math.max(
              1,
              Date.now() - startedAt
            );

            finishGesture(
              deltaX,
              deltaY,
              elapsed
            );
          });

          addLocalListener(element, 'pointercancel', event => {
            if (
              pointerId === null ||
              event.pointerId === pointerId
            ) {
              reset();
            }
          });

          return () => {
            localCleanups.forEach(cleanup => {
              try {
                cleanup();
              } catch (error) {
                /* Removing an already-removed listener is harmless. */
              }
            });
            localCleanups.length = 0;
            reset();
          };
        };

        const movePage = direction => {
          const currentIndex =
            pageOrder.indexOf(currentPage);
          const nextIndex =
            (
              currentIndex +
              direction +
              pageOrder.length
            ) % pageOrder.length;

          return changePage(
            pageOrder[nextIndex]
          );
        };

        const disablePageFallbackSwipe = () => {
          if (typeof removePageFallbackSwipe === 'function') {
            removePageFallbackSwipe();
          }

          removePageFallbackSwipe = null;
          delete root.dataset.usmSwiperFallback;
        };

        const enablePageFallbackSwipe = () => {
          if (
            desktopQuery.matches ||
            swiperInstance ||
            typeof removePageFallbackSwipe === 'function'
          ) {
            return;
          }

          removePageFallbackSwipe = addSwipe(
            viewport,
            () => movePage(1),
            () => movePage(-1)
          );

          root.dataset.usmSwiperFallback = 'true';
        };

        const destroySwiper = () => {
          swiperInitToken += 1;
          disablePageFallbackSwipe();
          swiperGestureStartX = null;
          swiperGestureMoved = false;

          if (
            swiperInstance &&
            !swiperInstance.destroyed
          ) {
            swiperInstance.destroy(true, true);
          }

          swiperInstance = null;
          delete root.dataset.usmSwiperError;

          if (desktopQuery.matches) {
            rail.style.transform = 'none';
          }
        };

        const syncCurrentPageFromSwiper = swiper => {
          const activeSlide =
            swiper.slides?.[swiper.activeIndex];
          const page =
            activeSlide?.dataset?.usmSlide;

          if (
            page &&
            pages[page] &&
            page !== currentPage
          ) {
            currentPage = page;
            render();
          }
        };

        const refreshSwiperGeometry = () => {
          if (
            !swiperInstance ||
            swiperInstance.destroyed ||
            desktopQuery.matches
          ) {
            return;
          }

          const nextOffset =
            getSwiperOffsetAfter();
          const currentOffset =
            Number(
              swiperInstance.params.slidesOffsetAfter || 0
            );

          if (
            Math.abs(nextOffset - currentOffset) > 0.5
          ) {
            swiperInstance.params.slidesOffsetAfter =
              nextOffset;
            swiperInstance.update();
          }
        };

        const getGestureClientX = event => {
          if (!event) {
            return null;
          }

          if (Number.isFinite(event.clientX)) {
            return event.clientX;
          }

          const touch =
            event.changedTouches?.[0] ||
            event.touches?.[0];

          return touch && Number.isFinite(touch.clientX)
            ? touch.clientX
            : null;
        };

        const initSwiper = SwiperConstructor => {
          if (
            isDestroyed ||
            desktopQuery.matches ||
            swiperInstance
          ) {
            return;
          }

          const initialIndex = Math.max(
            0,
            pageOrder.indexOf(currentPage)
          );

          disablePageFallbackSwipe();

          try {
            swiperInstance = new SwiperConstructor(
              viewport,
              {
                direction: 'horizontal',
                effect: 'slide',
                rewind: true,
                wrapperClass: 'ebms-usm-v2__rail',
                slideClass: 'ebms-usm-v2__slide',
                slidesPerView: 'auto',
                spaceBetween: tabletQuery.matches
                  ? 16
                  : 10,
                slidesOffsetAfter:
                  getSwiperOffsetAfter(),
                initialSlide: initialIndex,
                speed: window.matchMedia(
                  '(prefers-reduced-motion: reduce)'
                ).matches
                  ? 0
                  : 300,
                grabCursor: true,
                watchOverflow: false,
                threshold: 5,
                touchAngle: 45,
                touchRatio: 1,
                followFinger: true,
                resistance: true,
                resistanceRatio: 0.85,
                shortSwipes: true,
                longSwipes: true,
                longSwipesMs: 300,
                longSwipesRatio: 0.5,
                preventInteractionOnTransition: false,
                simulateTouch: true,
                touchStartPreventDefault: false,
                preventClicks: true,
                preventClicksPropagation: true,
                observer: true,
                observeParents: true,
                breakpoints: {
                  0: {
                    spaceBetween: 10
                  },
                  750: {
                    spaceBetween: 16
                  }
                },
                on: {
                  touchStart(swiper, event) {
                    swiperGestureStartX =
                      getGestureClientX(event);
                    swiperGestureMoved = false;
                  },
                  sliderMove(swiper, event) {
                    const currentX =
                      getGestureClientX(event);

                    if (
                      swiperGestureStartX !== null &&
                      currentX !== null &&
                      Math.abs(
                        currentX - swiperGestureStartX
                      ) >= 5
                    ) {
                      swiperGestureMoved = true;
                      suppressClickUntil =
                        Date.now() + 420;
                    }
                  },
                  touchEnd() {
                    if (swiperGestureMoved) {
                      suppressClickUntil =
                        Date.now() + 420;
                    }

                    swiperGestureStartX = null;
                    swiperGestureMoved = false;
                  },
                  slideChange(swiper) {
                    if (swiperGestureMoved) {
                      suppressClickUntil =
                        Date.now() + 420;
                    }

                    syncCurrentPageFromSwiper(swiper);
                  },
                  resize() {
                    refreshSwiperGeometry();
                  }
                }
              }
            );

            delete root.dataset.usmSwiperError;
            render();
          } catch (error) {
            swiperInstance = null;
            root.dataset.usmSwiperError =
              'initialization-failed';
            enablePageFallbackSwipe();
            positionRail();
          }
        };

        const syncSwiperMode = () => {
          if (desktopQuery.matches) {
            destroySwiper();
            return;
          }

          if (
            swiperInstance &&
            !swiperInstance.destroyed
          ) {
            refreshSwiperGeometry();
            positionRail();
            return;
          }

          const token = ++swiperInitToken;

          ensureSwiper()
            .then(SwiperConstructor => {
              if (
                isDestroyed ||
                desktopQuery.matches ||
                token !== swiperInitToken
              ) {
                return;
              }

              initSwiper(SwiperConstructor);
            })
            .catch(() => {
              if (
                !isDestroyed &&
                token === swiperInitToken
              ) {
                root.dataset.usmSwiperError =
                  'load-failed';
                enablePageFallbackSwipe();
                positionRail();
              }
            });
        };

        /*
          The page carousel now uses the same Swiper 12.2.0 touch engine
          as the proven reference section. The description card keeps
          its separate swipe behavior because it navigates sections,
          not pages.
        */
        syncSwiperMode();

        const removeCardSwipe = addSwipe(
          card,
          () => moveSection(1),
          () => moveSection(-1)
        );
        cleanupTasks.push(removeCardSwipe);

        const onViewportResize = () => {
          refreshSwiperGeometry();
          positionRail();
        };

        if ('ResizeObserver' in window) {
          const resizeObserver =
            new ResizeObserver(onViewportResize);
          resizeObserver.observe(viewport);
          cleanupTasks.push(() => {
            resizeObserver.disconnect();
          });
        } else {
          listen(window, 'resize', onViewportResize);
        }

        const onDesktopModeChange = () => {
          syncSwiperMode();
          render();
        };

        if (
          typeof desktopQuery.addEventListener ===
            'function'
        ) {
          listen(
            desktopQuery,
            'change',
            onDesktopModeChange
          );
        } else if (
          typeof desktopQuery.addListener ===
            'function'
        ) {
          desktopQuery.addListener(
            onDesktopModeChange
          );
          cleanupTasks.push(() => {
            desktopQuery.removeListener(
              onDesktopModeChange
            );
          });
        }

        const onTabletModeChange = () => {
          refreshSwiperGeometry();
          positionRail();
        };

        if (
          typeof tabletQuery.addEventListener ===
            'function'
        ) {
          listen(
            tabletQuery,
            'change',
            onTabletModeChange
          );
        } else if (
          typeof tabletQuery.addListener ===
            'function'
        ) {
          tabletQuery.addListener(
            onTabletModeChange
          );
          cleanupTasks.push(() => {
            tabletQuery.removeListener(
              onTabletModeChange
            );
          });
        }

        root.__ebmsUsmV2Cleanup = () => {
          isDestroyed = true;
          destroySwiper();

          cleanupTasks
            .splice(0)
            .reverse()
            .forEach(cleanup => {
              try {
                cleanup();
              } catch (error) {
                /* No-op: cleanup must never break the theme editor. */
              }
            });

          delete root.__ebmsUsmV2Cleanup;
          delete root.dataset.usmInitialized;
        };

        render();
      }
    };

    window[managerKey] = manager;

    document.addEventListener(
      'shopify:section:load',
      event => {
        manager.boot(event.target || document);
      }
    );

    document.addEventListener(
      'shopify:section:unload',
      event => {
        manager.destroy(event.target || document);
      }
    );

    manager.boot(document);
  })();
